import React from "react"

const EmptyStateImage = () => {
  return (
    <svg
      role="img"
      width="217"
      height="177"
      viewBox="0 0 217 177"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-design-system="EmptyStateImage"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.975 0.0116146C144.033 0.0116146 143.174 0.0588898 142.291 0.106135C115.639 1.61846 104.009 26.0993 104.009 26.0993V26.1112C101.455 21.2787 98.1702 16.8718 94.2618 13.0556C86.0097 4.69062 74.7675 0 63.032 0C34.4852 0 10.8608 23.3702 16.0743 58.3303C21.2878 93.2903 56.0978 122.084 103.999 153.419H104.011C125.529 140.127 145.634 124.661 164.023 107.269C176.313 95.8676 185.424 81.4413 190.474 65.42C191.11 63.0925 191.616 60.7176 191.981 58.3309C197.137 23.3811 173.523 0.0127035 144.975 0.0127035L144.975 0.0116146Z"
        fill="#E8F7F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M144.935 11.4176C128.227 11.4176 114.586 22.2129 104.011 43.8035C101.965 39.9322 85.7264 11.0607 62.8649 10.5645C40.0034 10.0682 22.4522 29.3314 26.6288 57.338C30.8054 85.3447 65.6294 116.449 104.003 141.552H104.013C121.251 130.904 171.288 94.4418 180.09 65.9702C188.891 37.4987 169.996 11.4176 144.935 11.4176Z"
        stroke="#232F3E"
        strokeWidth="2"
      />
      <path
        d="M160.848 102.862L151.818 93.8712L143.391 102.262L152.42 111.253L160.848 102.862Z"
        fill="#E8F7F9"
      />
      <path
        d="M124.535 133.802L125.204 121.105L113.302 120.484L112.633 133.181L124.535 133.802Z"
        fill="#E8F7F9"
      />
      <path
        d="M92.1857 133.802L92.854 121.105L80.9521 120.484L80.2838 133.181L92.1857 133.802Z"
        fill="#E8F7F9"
      />
      <path
        d="M33.8069 73.6081L34.9653 51.6002L23.0635 50.9791L21.9051 72.987L33.8069 73.6081Z"
        fill="#E8F7F9"
      />
      <path
        d="M178.725 75.7377L169.695 66.7474L161.268 75.1384L170.297 84.1287L178.725 75.7377Z"
        fill="#E8F7F9"
      />
      <path
        d="M186.888 42.0694L185.701 25.1583L169.565 26.2817L170.753 43.1928L186.888 42.0694Z"
        fill="#E8F7F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.3516 101.296L52.0971 109.515L59.8013 117.186L68.0558 108.967L60.3516 101.296Z"
        fill="#E8F7F9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.0083 76.5002L35.7538 84.719L43.458 92.3899L51.7125 84.1711L44.0083 76.5002Z"
        fill="#E8F7F9"
      />
      <g filter="url(#filter0_d_3559_35937)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.6776 136.148C41.7319 127.492 52.6078 119.978 57.3054 113.607C61.7199 107.62 63.848 99.1997 63.6897 88.3466C63.672 87.1354 62.7269 86.1389 61.5135 86.052C48.6723 85.1326 39.6395 87.2739 34.4149 92.4759C28.9077 97.9593 21.1044 107.838 11.0049 122.111L24.6776 136.148Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3068 136.23C40.6163 125.944 51.7281 117.648 56.6422 111.343C61.1974 105.498 63.3197 97.7371 63.0091 88.0608C62.9677 86.7722 61.885 85.7609 60.5907 85.8021C60.5829 85.8024 60.5751 85.8027 60.5673 85.803C49.1263 86.2815 40.789 89.1262 35.5553 94.3372C29.9737 99.8947 22.1037 109.945 11.9452 124.489L23.3068 136.23Z"
          fill="#4E8B7C"
        />
        <path
          opacity="0.31685"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57.1599 97.0573L54.0582 101.554C53.5695 102.263 52.5965 102.443 51.8849 101.956C51.806 101.902 51.7322 101.841 51.6645 101.774L46.4978 96.6294C45.8874 96.0216 45.8874 95.0362 46.4978 94.4284C46.5655 94.361 46.6393 94.3 46.7182 94.246L51.2347 91.1577C51.8556 90.7332 52.6923 90.8099 53.2248 91.3402L56.9767 95.0758C57.5093 95.6061 57.5863 96.4391 57.1599 97.0573Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.8329 133.301C36.7056 126.743 44.3415 121.158 47.7406 116.547C52.8393 109.629 36.4355 94.5867 30.4571 100.539C26.4714 104.508 21.1354 111.967 14.4491 122.917L24.8329 133.301Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.4021 119.828C46.7539 118.527 48.8947 116.418 51.8245 113.501C53.6752 111.658 52.2591 105.003 48.4576 101.295C44.3926 97.3293 38.8494 96.5338 35.6579 98.1685C33.5302 99.2584 31.4376 101.161 29.3799 103.875C34.6418 100.978 39.5823 101.828 44.2013 106.427C48.8204 111.027 49.2206 115.493 45.4021 119.828Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.1279 129.985L17.9142 134.181L13.0985 129.386L14.8124 127.68L17.3122 125.191L22.1279 129.985Z"
          fill="#121626"
        />
        <path
          d="M42.0699 98.6025L39.127 103.131"
          stroke="#232F3E"
          strokeWidth="0.918048"
          strokeLinecap="square"
        />
        <path
          d="M49.4736 106.178C49.967 106.082 49.7993 106.376 48.9706 107.06C48.1418 107.744 46.8186 108.681 45.0012 109.87"
          stroke="#232F3E"
          strokeWidth="0.918048"
          strokeLinecap="square"
        />
      </g>
      <g filter="url(#filter1_d_3559_35937)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M103.744 49.1619C103.744 49.1619 122.749 74.8703 122.749 88.893C122.749 102.916 118.363 164.85 118.363 164.85C118.363 164.85 115.439 169.524 103.744 169.524C92.0485 169.524 87.6627 164.85 87.6627 164.85C87.6627 164.85 83.2769 98.2415 84.7388 86.5559C86.2008 74.8703 103.744 49.1619 103.744 49.1619Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M103.946 57.6381C103.946 57.6381 109.511 65.4179 113.385 73.6014C113.385 73.6014 107.779 71.9633 103.953 71.923C100.214 71.8839 94.6561 73.7429 94.6561 73.7429C98.5394 65.8285 103.946 57.6381 103.946 57.6381Z"
          fill="#6ACBDD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M117.641 94.0857L114.52 78.3438C114.52 78.3438 109.838 77.1334 103.595 77.1334C97.3514 77.1334 92.6698 78.3438 92.6698 78.3438L89.5482 94.0857C89.5482 94.0857 94.8547 91.8254 103.595 91.8254C112.336 91.8254 117.641 94.0857 117.641 94.0857Z"
          fill="#6ACBDD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100.591 138.162H103.193C110.203 138.162 115.938 133.714 115.938 128.277V109.057C115.938 103.62 110.203 99.1714 103.193 99.1714H100.591C93.5809 99.1714 87.8455 103.62 87.8455 109.057V128.277C87.8455 133.714 93.5809 138.162 100.591 138.162Z"
          fill="#D8EEEF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M102.743 142.4C109.064 142.4 114.236 138.338 114.236 133.373V109.893C114.236 104.929 109.064 100.867 102.743 100.867C96.4227 100.867 91.2507 104.929 91.2507 109.893V133.373C91.2507 138.338 96.4227 142.4 102.743 142.4Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95.051 134.771H109.583C110.742 134.771 111.682 134.07 111.682 133.204V109.465C111.682 105.653 107.547 102.562 102.446 102.562C97.2025 102.562 92.9535 105.739 92.9535 109.657V133.204C92.9535 134.07 93.8922 134.771 95.051 134.771Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.7263 135.619H109.908C110.887 135.619 111.682 135.007 111.682 134.252V117.905C111.682 114.581 108.187 111.886 103.875 111.886H100.976C96.5453 111.886 92.9535 114.655 92.9535 118.072V134.252C92.9535 135.007 93.7476 135.619 94.7263 135.619Z"
          fill="#232F3E"
        />
        <path
          opacity="0.336102"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M94.4893 143.248H110.146C110.994 143.248 111.682 143.753 111.682 144.376V155.235C111.682 157.977 108.655 160.2 104.922 160.2H99.9017C96.0637 160.2 92.9535 157.916 92.9535 155.097V144.376C92.9535 143.753 93.6414 143.248 94.4893 143.248Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M108.277 101.714H106.574V96.6286H108.277V101.714Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.533 105.952H110.831V100.019H112.533V105.952Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M99.7637 101.714H98.0611V96.6286H99.7637V101.714Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95.5073 105.952H93.8047V100.019H95.5073V105.952Z"
          fill="#FEFEFE"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.979 111.611C109.979 110.827 108.635 110.191 106.976 110.191H106.061C104.402 110.191 103.058 110.827 103.058 111.611V113.242H109.979V111.611Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M102.429 111.611C102.429 110.827 101.118 110.191 99.5004 110.191H98.6077C96.9904 110.191 95.6794 110.827 95.6794 111.611L95.5073 113.242H102.429V111.611Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.979 114.566C109.979 114.958 108.635 115.276 106.976 115.276H106.061C104.402 115.276 103.058 114.958 103.058 114.566V113.75H109.979V114.566Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M102.429 114.566C102.429 114.958 101.118 115.276 99.5004 115.276H98.6077C96.9904 115.276 95.6794 114.958 95.6794 114.566L95.5073 113.75H102.429V114.566Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.979 146.364C109.979 145.579 108.635 144.943 106.976 144.943H106.061C104.402 144.943 103.058 145.579 103.058 146.364V147.994H109.979V146.364Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M102.429 146.364C102.429 145.579 101.118 144.943 99.5004 144.943H98.6077C96.9904 144.943 95.6794 145.579 95.6794 146.364L95.5073 147.994H102.429V146.364Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.979 149.318C109.979 149.711 108.635 150.029 106.976 150.029H106.061C104.402 150.029 103.058 149.711 103.058 149.318V148.503H109.979V149.318Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M102.429 149.318C102.429 149.711 101.118 150.029 99.5004 150.029H98.6077C96.9904 150.029 95.6794 149.711 95.6794 149.318L95.5073 148.503H102.429V149.318Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.7467 135.619C98.3905 135.619 98.9125 134.309 98.9125 132.693V131.801C98.9125 130.184 98.3905 128.874 97.7467 128.874H96.4087V135.619H97.7467Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M97.7467 128.261C98.3905 128.261 98.9125 126.983 98.9125 125.407V124.537C98.9125 122.962 98.3905 121.684 97.7467 121.684L96.4087 121.516V128.261H97.7467Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95.1225 135.312C94.865 135.312 94.6562 134.002 94.6562 132.386V131.494C94.6562 129.878 94.865 128.568 95.1225 128.568H95.6577V135.312H95.1225Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95.1225 127.954C94.865 127.954 94.6562 126.677 94.6562 125.101V124.231C94.6562 122.655 94.865 121.377 95.1225 121.377L95.6577 121.21V127.954H95.1225Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M106.889 135.619C106.245 135.619 105.723 134.309 105.723 132.693V131.801C105.723 130.184 106.245 128.874 106.889 128.874H108.227V135.619H106.889Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M106.889 128.261C106.245 128.261 105.723 126.983 105.723 125.407V124.537C105.723 122.962 106.245 121.684 106.889 121.684L108.227 121.516V128.261H106.889Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.513 135.312C109.771 135.312 109.98 134.002 109.98 132.386V131.494C109.98 129.878 109.771 128.568 109.513 128.568H108.978V135.312H109.513Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.513 127.954C109.771 127.954 109.98 126.677 109.98 125.101V124.231C109.98 122.655 109.771 121.377 109.513 121.377L108.978 121.21V127.954H109.513Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_d_3559_35937)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M139.078 56.5199C139.078 56.5199 133.374 72.8237 140.915 87.3029C148.455 101.782 180.465 132.831 180.465 132.831C180.465 132.831 185.677 132.167 191.61 127.552C197.543 122.937 200.277 119.116 200.277 119.116C200.277 119.116 177.295 77.6543 165.834 67.9201C154.373 58.1858 139.121 58.3138 139.121 58.3138L139.078 56.5199Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M137.248 57.0855C137.248 57.0855 134.468 71.4579 142.598 86.0645C150.729 100.671 182.915 133.194 182.915 133.194C182.915 133.194 187.718 132.946 192.891 128.923C198.063 124.9 200.316 121.403 200.316 121.403C200.316 121.403 175.74 79.4717 164.322 69.1671C152.903 58.8624 137.248 57.0855 137.248 57.0855Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M139.998 61.2967C139.998 61.2967 134.836 77.7354 155.653 98.6162C155.653 98.6162 156.781 95.7114 163.13 90.7732C169.479 85.835 172.583 85.4477 172.583 85.4477C172.583 85.4477 163.395 61.2747 141.45 60.1669L139.998 61.2967Z"
          fill="#E8282F"
        />
        <path
          opacity="0.250873"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M189.108 128.672C186.91 130.381 183.277 129.409 180.994 126.499L160.459 102.413C158.176 99.5036 158.107 95.7589 160.305 94.049L169.776 86.6829C171.974 84.9732 175.607 85.9459 177.89 88.8552L196.195 114.676C198.478 117.585 198.547 121.33 196.349 123.04L189.108 128.672Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M193.097 120.689L199.39 128.708L192.014 134.444L188.975 130.571L185.722 126.426L193.097 120.689Z"
          fill="#121626"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M179.234 101.903L171.157 108.186C168.704 110.094 165.669 110.305 164.376 108.657L152.194 95.4544C150.901 93.8073 151.841 90.9258 154.294 89.0185L164.858 80.8012C167.311 78.8938 170.346 78.6828 171.639 80.3299L181.334 95.4674C182.627 97.1146 181.686 99.9961 179.234 101.903Z"
          fill="#232F3E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M157.841 99.0422C157.06 98.0479 157.785 96.1858 159.46 94.8833L160.384 94.1644C162.059 92.8618 164.049 92.6121 164.829 93.6065L166.451 95.6729L159.462 101.109L157.841 99.0422Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M165.22 93.3018C164.44 92.3075 165.204 90.4145 166.928 89.0738L167.88 88.3337C169.603 86.9931 171.633 86.7123 172.414 87.7067L174.219 89.6305L166.842 95.3683L165.22 93.3018Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M160.518 102.455C160.865 102.897 162.504 102.199 164.179 100.897L165.103 100.178C166.778 98.8748 167.855 97.4604 167.508 97.0184L166.787 96.0998L159.797 101.537L160.518 102.455Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M167.897 96.7149C168.244 97.1569 169.923 96.4282 171.647 95.0872L172.598 94.347C174.322 93.0061 175.438 91.5607 175.092 91.1187L174.554 90.0574L167.176 95.7963L167.897 96.7149Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M150.558 94.3043C150.558 94.3043 148.998 89.5069 157.566 83.9698L162.692 90.5017C162.692 90.5017 157.802 94.3049 156.945 97.2258L150.558 94.3043Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M170.161 79.3738C170.161 79.3738 165.863 76.7061 158.393 83.643L163.519 90.175C163.519 90.175 168.409 86.3718 171.463 86.2506L170.161 79.3738Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M158.663 83.804L159.333 83.2827L147.278 67.9197L146.607 68.441L158.663 83.804Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.10979 69.0779C1.10979 69.0779 1.324 69.0939 1.73048 69.1212C1.93371 69.1348 2.18088 69.1531 2.47749 69.1735C2.77964 69.1798 3.12575 69.1835 3.52131 69.187C3.92234 69.1977 4.35093 69.1727 4.82897 69.1546C5.30696 69.1484 5.81808 69.0899 6.36775 69.0265C6.50515 69.0118 6.64804 68.9948 6.79093 68.9801C6.93386 68.9512 7.07129 68.9247 7.21972 68.8981C7.35166 68.8692 7.47806 68.8546 7.61553 68.8162C7.7585 68.7754 7.91248 68.7298 8.06095 68.689C8.64936 68.5091 9.09506 68.2869 9.53534 68.0505C10.3829 67.5706 11.1369 67.1196 12.2202 66.7886C13.2926 66.4482 14.5126 66.3353 15.8417 66.4667C17.1874 66.5885 18.5707 66.95 20.0146 67.3185C21.4694 67.6893 22.9734 68.1146 24.7414 68.4323C25.6475 68.5839 26.5536 68.7094 27.6687 68.7464C28.1247 68.7522 28.4927 68.7748 29.0421 68.7613C29.2949 68.7582 29.5586 68.755 29.8058 68.7471L30.5367 68.7022C32.4819 68.5847 34.3019 68.1186 35.5723 67.666C36.7273 67.2707 37.7109 67.1799 38.996 67.3778C39.1662 67.4034 39.3639 67.4266 39.5176 67.4546L39.9569 67.5364C40.2479 67.5807 40.5553 67.6652 40.8518 67.7237C41.4448 67.8573 42.0212 68.0028 42.5757 68.1507C43.1356 68.2939 43.6736 68.4395 44.2171 68.5661C44.3489 68.5966 44.4861 68.627 44.6179 68.6575L44.7167 68.6809L44.7991 68.6997L44.8485 68.709L45.0462 68.7441C45.3097 68.7908 45.5458 68.8423 45.8534 68.8746C47.0066 69.0302 47.9846 69.0059 48.7704 68.9632C49.5561 68.9134 50.1388 68.8332 50.5345 68.7798C50.9247 68.7216 51.1336 68.6925 51.1336 68.6925C51.1336 68.6925 50.9193 68.7027 50.5017 68.7182C50.0951 68.736 49.4907 68.7426 48.7491 68.7377C48.0129 68.7209 47.0956 68.6524 46.2557 68.4792C46.0525 68.4466 45.811 68.3737 45.5694 68.3127L45.3883 68.2634L45.3444 68.2516C45.3993 68.2633 45.3334 68.2469 45.3334 68.2445L45.2456 68.2163L44.8998 68.1057C44.4333 67.9504 43.9449 67.7857 43.4289 67.6139C42.913 67.4397 42.3587 67.2538 41.7495 67.0727C41.4256 66.9859 41.1402 66.8941 40.7614 66.8121C40.3935 66.7254 40.0257 66.6434 39.6907 66.5874C38.9605 66.4424 37.9554 66.3266 36.939 66.3772C36.4335 66.393 35.9278 66.461 35.477 66.5478C35.2461 66.5841 35.0152 66.6466 34.7843 66.7019C34.5259 66.762 34.4213 66.8051 34.2289 66.8579L33.712 67.009C33.558 67.0522 33.404 67.1026 33.2446 67.1434C32.9202 67.218 32.6013 67.3045 32.255 67.3625C31.5898 67.4951 30.8754 67.5756 30.15 67.6277L29.6005 67.6578C29.4192 67.6631 29.2434 67.6612 29.0621 67.6642C28.7489 67.6794 28.249 67.65 27.8315 67.6394C27.2108 67.6151 26.4254 67.5154 25.7171 67.3869C24.2455 67.1372 22.7964 66.7498 21.2867 66.3767C19.777 66.0037 18.1574 65.6357 16.268 65.4942C15.3342 65.4258 14.3124 65.4312 13.3889 65.5551C12.4656 65.6766 11.6572 65.888 11.0137 66.1321C10.6947 66.2542 10.3371 66.3977 10.1225 66.51C9.99047 66.5793 9.90797 66.6104 9.73736 66.7059L9.38511 66.9112C8.96122 67.1855 8.62526 67.4548 8.3004 67.6838C7.98104 67.9127 7.6288 68.118 7.27673 68.2639L7.02367 68.3739C6.93015 68.4098 6.78721 68.4411 6.67173 68.477C6.56725 68.5058 6.46278 68.5347 6.35829 68.5658C6.23736 68.5852 6.12192 68.6069 6.01198 68.631C5.55022 68.7179 5.11046 68.7976 4.6708 68.844C4.23662 68.8952 3.84087 68.9557 3.47272 68.9711C3.09904 68.9983 2.76934 69.0231 2.48358 69.0453C2.18139 69.0533 1.92864 69.0612 1.72535 69.0666C1.32976 69.0725 1.10979 69.0779 1.10979 69.0779Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8838 58.9623C10.9833 58.9761 11.1043 58.9946 11.2494 59.0153C11.3974 59.0217 11.5668 59.0256 11.7604 59.0294C11.9567 59.0403 12.1666 59.0153 12.4006 58.9974C12.6346 58.9914 12.8848 58.9327 13.1539 58.8692C13.2212 58.8545 13.2912 58.8374 13.3611 58.8227C13.4311 58.7937 13.4984 58.767 13.5711 58.7404C13.6357 58.7114 13.6976 58.6967 13.7649 58.6581C13.8349 58.6171 13.9103 58.5714 13.983 58.5303C14.2711 58.3496 14.4894 58.1263 14.7051 57.8886C15.1202 57.4061 15.4896 56.9526 16.02 56.6201C16.5452 56.278 17.1425 56.165 17.7931 56.2978C18.4517 56.421 19.1288 56.7855 19.8354 57.1569C20.5474 57.5308 21.2835 57.9594 22.1488 58.2799C22.5923 58.4329 23.0358 58.5597 23.5817 58.5974C23.8049 58.6034 23.9851 58.6264 24.254 58.613C24.3778 58.61 24.5069 58.607 24.6279 58.5992L24.9857 58.5543C25.938 58.437 26.8292 57.9688 27.4513 57.5139C28.0169 57.1167 28.4985 57.0258 29.1275 57.2256C29.2108 57.2515 29.3076 57.2749 29.3828 57.3032L29.5978 57.3857C29.7403 57.4303 29.8907 57.5156 30.0358 57.5746C30.326 57.7092 30.6081 57.8559 30.8795 58.005C31.1535 58.1494 31.4168 58.2962 31.6828 58.4238C31.7473 58.4545 31.8145 58.4852 31.879 58.516L31.9274 58.5396L31.9677 58.5585L31.9919 58.568L32.0886 58.6033C32.2176 58.6504 32.3331 58.7024 32.4837 58.735C33.0482 58.8922 33.5269 58.8682 33.9116 58.8256C34.2963 58.7758 34.5816 58.6954 34.7753 58.6419C34.9664 58.5835 35.0686 58.5543 35.0686 58.5543C35.0686 58.5543 34.9637 58.5644 34.7593 58.5798C34.5602 58.5976 34.2644 58.6039 33.9013 58.5986C33.5409 58.5814 33.0919 58.512 32.6808 58.3374C32.5814 58.3044 32.4632 58.231 32.345 58.1695L32.2563 58.1197L32.2348 58.1079C32.2617 58.1197 32.2295 58.1032 32.2295 58.1008L32.1865 58.0723L32.0173 57.9609C31.789 57.8044 31.5499 57.6384 31.2975 57.4652C31.045 57.2897 30.7737 57.1024 30.4756 56.9199C30.3171 56.8324 30.1774 56.7399 29.992 56.6572C29.812 56.5698 29.6319 56.4871 29.468 56.4306C29.1106 56.2843 28.6186 56.1674 28.121 56.2177C27.8735 56.2334 27.6259 56.3016 27.4052 56.3887C27.2922 56.4252 27.1791 56.4879 27.066 56.5434C26.9395 56.6038 26.8883 56.6471 26.7941 56.7002L26.5409 56.852C26.4656 56.8954 26.3902 56.946 26.3121 56.987C26.1532 57.0619 25.9971 57.1488 25.8275 57.207C25.5018 57.3401 25.152 57.4208 24.7969 57.4728L24.5279 57.5029C24.4391 57.5081 24.3531 57.5062 24.2643 57.5091C24.111 57.5242 23.8663 57.4944 23.6619 57.4835C23.3581 57.4588 22.9737 57.3581 22.627 57.2285C21.9067 56.9765 21.1975 56.586 20.4586 56.2099C19.7198 55.8338 18.9271 55.4628 18.0022 55.3194C17.5451 55.2501 17.0449 55.2551 16.5928 55.3793C16.1407 55.5012 15.7449 55.7135 15.4297 55.9589C15.2735 56.0816 15.0984 56.2258 14.9933 56.3387C14.9286 56.4083 14.8882 56.4396 14.8046 56.5356L14.6321 56.742C14.4244 57.0179 14.2598 57.2888 14.1007 57.519C13.9443 57.7492 13.7717 57.9556 13.5993 58.1022L13.4754 58.2128C13.4296 58.2489 13.3596 58.2803 13.303 58.3164C13.2519 58.3454 13.2007 58.3743 13.1495 58.4056C13.0903 58.4251 13.0338 58.4469 12.98 58.471C12.7539 58.5582 12.5386 58.6382 12.3233 58.6847C12.1107 58.736 11.917 58.7968 11.7368 58.8121C11.5538 58.8393 11.3924 58.864 11.2525 58.8863C11.1046 58.8942 10.9808 58.902 10.8813 58.9073C10.6876 58.9131 10.58 58.9184 10.58 58.9184C10.58 58.9184 10.6848 58.9346 10.8838 58.9623Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M165.411 41.1065C165.411 41.1065 165.625 41.1225 166.032 41.1497C166.235 41.1634 166.482 41.1816 166.779 41.2021C167.081 41.2083 167.427 41.212 167.823 41.2156C168.224 41.2263 168.652 41.2012 169.13 41.1832C169.608 41.177 170.119 41.1185 170.669 41.0551C170.806 41.0404 170.949 41.0233 171.092 41.0087C171.235 40.9797 171.373 40.9532 171.521 40.9266C171.653 40.8978 171.779 40.8831 171.917 40.8447C172.06 40.8039 172.214 40.7583 172.362 40.7175C172.951 40.5377 173.396 40.3155 173.837 40.0791C174.684 39.5992 175.438 39.1482 176.522 38.8172C177.594 38.4768 178.814 38.3639 180.143 38.4952C181.489 38.617 182.872 38.9786 184.316 39.3471C185.771 39.7179 187.275 40.1432 189.043 40.4608C189.949 40.6125 190.855 40.738 191.97 40.775C192.426 40.7807 192.794 40.8034 193.343 40.7898C193.596 40.7867 193.86 40.7835 194.107 40.7757L194.838 40.7307C196.783 40.6133 198.603 40.1471 199.874 39.6945C201.029 39.2992 202.012 39.2084 203.297 39.4064C203.467 39.432 203.665 39.4552 203.819 39.4832L204.258 39.565C204.549 39.6092 204.857 39.6938 205.153 39.7523C205.746 39.8858 206.322 40.0313 206.877 40.1793C207.437 40.3224 207.975 40.468 208.518 40.5946C208.65 40.6251 208.787 40.6556 208.919 40.686L209.018 40.7095L209.1 40.7282L209.15 40.7376L209.347 40.7726C209.611 40.8193 209.847 40.8709 210.155 40.9032C211.308 41.0588 212.286 41.0345 213.072 40.9918C213.857 40.9419 214.44 40.8618 214.836 40.8084C215.226 40.7502 215.435 40.7211 215.435 40.7211C215.435 40.7211 215.221 40.7312 214.803 40.7467C214.396 40.7646 213.792 40.7711 213.05 40.7662C212.314 40.7495 211.397 40.681 210.557 40.5078C210.354 40.4751 210.112 40.4023 209.871 40.3413L209.69 40.2919L209.646 40.2802C209.701 40.2919 209.635 40.2755 209.635 40.2731L209.547 40.2449L209.201 40.1343C208.735 39.979 208.246 39.8142 207.73 39.6424C207.214 39.4683 206.66 39.2823 206.051 39.1013C205.727 39.0144 205.441 38.9227 205.063 38.8407C204.695 38.7539 204.327 38.6719 203.992 38.616C203.262 38.4709 202.257 38.3552 201.24 38.4058C200.735 38.4215 200.229 38.4895 199.778 38.5764C199.547 38.6127 199.316 38.6751 199.086 38.7304C198.827 38.7906 198.723 38.8336 198.53 38.8865L198.013 39.0376C197.859 39.0808 197.705 39.1311 197.546 39.172C197.221 39.2466 196.903 39.333 196.556 39.3911C195.891 39.5237 195.177 39.6042 194.451 39.6562L193.902 39.6864C193.72 39.6917 193.545 39.6898 193.363 39.6927C193.05 39.7079 192.55 39.6785 192.133 39.6679C191.512 39.6437 190.727 39.5439 190.018 39.4155C188.547 39.1658 187.098 38.7783 185.588 38.4053C184.078 38.0323 182.459 37.6643 180.569 37.5228C179.635 37.4543 178.614 37.4598 177.69 37.5837C176.767 37.7052 175.959 37.9166 175.315 38.1607C174.996 38.2828 174.638 38.4263 174.424 38.5386C174.292 38.6078 174.209 38.6389 174.039 38.7344L173.686 38.9397C173.262 39.2141 172.927 39.4834 172.602 39.7123C172.282 39.9413 171.93 40.1465 171.578 40.2924L171.325 40.4024C171.231 40.4383 171.088 40.4696 170.973 40.5056C170.869 40.5344 170.764 40.5632 170.66 40.5944C170.539 40.6138 170.423 40.6355 170.313 40.6596C169.851 40.7464 169.412 40.8261 168.972 40.8726C168.538 40.9237 168.142 40.9843 167.774 40.9996C167.4 41.0269 167.071 41.0516 166.785 41.0739C166.483 41.0819 166.23 41.0898 166.027 41.0951C165.631 41.1011 165.411 41.1065 165.411 41.1065Z"
        fill="#6ACBDD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M175.185 30.9908C175.285 31.0046 175.406 31.0231 175.551 31.0439C175.699 31.0503 175.868 31.0542 176.062 31.0579C176.258 31.0689 176.468 31.0439 176.702 31.0259C176.936 31.0199 177.186 30.9613 177.455 30.8978C177.522 30.8831 177.592 30.866 177.662 30.8513C177.732 30.8222 177.8 30.7956 177.872 30.7689C177.937 30.7399 177.999 30.7253 178.066 30.6867C178.136 30.6457 178.212 30.5999 178.284 30.5589C178.572 30.3782 178.791 30.1548 179.006 29.9171C179.421 29.4347 179.791 28.9812 180.321 28.6486C180.846 28.3066 181.444 28.1935 182.094 28.3264C182.753 28.4496 183.43 28.814 184.137 29.1855C184.849 29.5593 185.585 29.988 186.45 30.3085C186.894 30.4615 187.337 30.5882 187.883 30.626C188.106 30.632 188.286 30.655 188.555 30.6416C188.679 30.6386 188.808 30.6355 188.929 30.6277L189.287 30.5828C190.239 30.4656 191.13 29.9974 191.753 29.5425C192.318 29.1453 192.8 29.0544 193.429 29.2542C193.512 29.2801 193.609 29.3034 193.684 29.3317L193.899 29.4142C194.042 29.4589 194.192 29.5441 194.337 29.6031C194.627 29.7378 194.909 29.8845 195.181 30.0336C195.455 30.1779 195.718 30.3247 195.984 30.4524C196.049 30.4831 196.116 30.5138 196.18 30.5445L196.229 30.5682L196.269 30.5871L196.293 30.5965L196.39 30.6319C196.519 30.679 196.634 30.7309 196.785 30.7636C197.349 30.9208 197.828 30.8968 198.213 30.8541C198.598 30.8044 198.883 30.724 199.077 30.6704C199.268 30.6121 199.37 30.5829 199.37 30.5829C199.37 30.5829 199.265 30.593 199.061 30.6084C198.862 30.6262 198.566 30.6325 198.203 30.6272C197.842 30.61 197.393 30.5406 196.982 30.3659C196.883 30.333 196.764 30.2595 196.646 30.198L196.558 30.1483L196.536 30.1365C196.563 30.1483 196.531 30.1317 196.531 30.1293L196.488 30.1009L196.319 29.9895C196.09 29.8329 195.851 29.6669 195.599 29.4938C195.346 29.3183 195.075 29.1309 194.777 28.9485C194.618 28.8609 194.479 28.7684 194.293 28.6858C194.113 28.5983 193.933 28.5156 193.769 28.4591C193.412 28.3128 192.92 28.1959 192.422 28.2463C192.175 28.2619 191.927 28.3301 191.706 28.4173C191.593 28.4537 191.48 28.5165 191.367 28.572C191.241 28.6324 191.19 28.6757 191.095 28.7287L190.842 28.8806C190.767 28.924 190.691 28.9746 190.613 29.0156C190.455 29.0905 190.298 29.1773 190.129 29.2356C189.803 29.3687 189.453 29.4494 189.098 29.5014L188.829 29.5315C188.74 29.5367 188.654 29.5348 188.566 29.5376C188.412 29.5528 188.168 29.523 187.963 29.5121C187.659 29.4874 187.275 29.3866 186.928 29.257C186.208 29.0051 185.499 28.6145 184.76 28.2384C184.021 27.8624 183.228 27.4913 182.303 27.348C181.846 27.2787 181.346 27.2837 180.894 27.4079C180.442 27.5297 180.046 27.7421 179.731 27.9874C179.575 28.1101 179.4 28.2544 179.295 28.3673C179.23 28.4369 179.189 28.4682 179.106 28.5642L178.933 28.7706C178.726 29.0465 178.561 29.3173 178.402 29.5475C178.246 29.7777 178.073 29.9841 177.901 30.1308L177.777 30.2414C177.731 30.2774 177.661 30.3089 177.604 30.345C177.553 30.3739 177.502 30.4029 177.451 30.4342C177.392 30.4536 177.335 30.4754 177.281 30.4996C177.055 30.5868 176.84 30.6668 176.625 30.7133C176.412 30.7646 176.218 30.8253 176.038 30.8406C175.855 30.8679 175.694 30.8926 175.554 30.9148C175.406 30.9228 175.282 30.9306 175.183 30.9359C174.989 30.9417 174.881 30.947 174.881 30.947C174.881 30.947 174.986 30.9632 175.185 30.9908Z"
        fill="#6ACBDD"
      />
      <defs>
        <filter
          id="filter0_d_3559_35937"
          x="6.00488"
          y="82.8009"
          width="62.6929"
          height="60.4292"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3559_35937"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3559_35937"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3559_35937"
          x="79.4404"
          y="46.1619"
          width="48.3086"
          height="130.362"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3559_35937"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3559_35937"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_3559_35937"
          x="131.79"
          y="53.52"
          width="73.5269"
          height="87.9244"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0660051 0 0 0 0 0.0806885 0 0 0 0 0.149267 0 0 0 0.159406 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3559_35937"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3559_35937"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default EmptyStateImage
